import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { toggleModal, toggleModalWithTimer } from 'apps/auth/actions/appAction';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { changeFormFieldValue } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import Form from 'apps/auth/components/form-multi/Form';
import { clearLeadingSpace, getSortFields } from 'apps/auth/components/form-multi/utils';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { SUGGESTED } from 'apps/auth/constants/formName';
import { useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const SuggestionModal = (props) => {
    const { fields } = useForm(SUGGESTED);
    const { suggestedHeader, suggestedSubmit, suggestedSuccess } = usePageMessages();
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        setDisabled(Object.values(fields).filter((f) => f?.visible && f?.mandatory && f?.value).length === 0);
    }, [fields]);

    const closeModal = () => {
        props.toggleModal(false).then(() => props.toggleModalWithTimer(false, '', false));
    };

    const submitHandler = () => {
        props.updateExtraByName('feedbackFormAvailable', null);
        props.toggleModalWithTimer(true, suggestedSuccess, closeModal);
    };

    const beforeSubmit = () => clearLeadingSpace(fields, SUGGESTED, props.changeFormFieldValue);

    return (
        <ModalComponent>
            <HeaderPanel title={suggestedHeader} />
            <Form
                action={`/auth/${props.funding ? 'funding' : 'delivery'}/option/suggested`}
                formName={SUGGESTED}
                onSubmitHandler={submitHandler}
                beforeSubmit={beforeSubmit}
            >
                {getSortFields(fields)
                    .filter((f) => f?.visible)
                    .map((field) => {
                        return (
                            <Row indent="adaptive-24-32" key={field.name}>
                                <InputAutoDetect formName={SUGGESTED} field={field} setMaxLength />
                            </Row>
                        );
                    })}
                <FixedBottomPanel isRightAligned>
                    <Button type="submit" disabled={disabled} raised={true} caption={suggestedSubmit} />
                </FixedBottomPanel>
            </Form>
        </ModalComponent>
    );
};

export default connect(null, { toggleModal, toggleModalWithTimer, updateExtraByName, changeFormFieldValue })(SuggestionModal);
